import angular from "angular";
import template from "./admin-school-vehicles-index.html";
import AdminSchoolsVehiclesIndexController from "./admin-school-vehicles-index.controller";

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.schools.vehicles.index", {
    url: "/:schoolId/index",
    controller: AdminSchoolsVehiclesIndexController,
    controllerAs: "vm",
    template: template,
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.dashboard.schools.vehicles.index", [])
  .config(config)
  .controller(
    "AdminSchoolsVehiclesIndexController",
    AdminSchoolsVehiclesIndexController,
  );

